<template>
	<div>
		<div ref="twoFactorBlock" class="d-flex flex-column align-items-center justify-content-center h-full-page">
			<h1 class="text-center mt-3">Scan QR Code</h1>
			<p class="text-center text-muted mt-1">Scan the QR Code with your Authenticator App.</p>

			<div class="mb-4">
				<div v-html="twoFactorSetupSvg"></div>
			</div>

			<p class="text-center text-muted my-1">or enter the setup key manually</p>
			<div class="d-flex align-items-center justify-content-between rounded-pill border py-2 px-3 input-container border-active-darken my-3">
				<input v-model="twoFactorSetupCode"  type="text" id="setup_key" name="setup_key" class="form-control m-0 border-0 fs-5 p-0 lh-fixed text-center" readonly >
				<label for="setup_key" v-tooltip="'Copy to clipboard'">
					<i class="me-3 dd-icon bi bi-copy" @click="helper.copyText(twoFactorSetupCode)"></i>
				</label>
			</div>

			<div class="d-flex flex-column py-4 gap-1 align-items-center w-100">
				<button class="btn btn-link" @click="moveButtonAction('skip')">skip for now</button>
				<button class="btn btn-dark rounded-pill py-7" :class="width < 992 ? 'w-75' : 'w-50'" @click="moveButtonAction('two-factor-verify')">Continue</button>
			</div>
		</div>
	</div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useAppHelpers } from "@/composables/useAppHelpers.js";
import { useAuthStore } from "@/stores/auth-store.js";

const props = defineProps({
	width: [String, Number],
	username: {
		type: String,
		default: null,
		require: false
	}
});
const emits = defineEmits(['navigationButtonClicked']);

const helper = useAppHelpers();
const auth = useAuthStore();

const twoFactorBlock = ref(null);
const twoFAQRCodes = ref(null);
const twoFactorSetupSvg = ref(null);
const twoFactorSetupCode = ref(null);

const moveButtonAction = async (name) => {
	if(name === 'skip') {
		try{
			helper.loaderOn(twoFactorBlock.value);
			const response = await auth.disableTwoFactor();
			helper.loaderOff(twoFactorBlock.value);
		}
		catch (error) {
			helper.loaderOff(twoFactorBlock.value);
			return;
		}
	}
	emits('navigationButtonClicked', name);
}

onMounted(async () => {
	await enableTwoFactor();
});

const enableTwoFactor = async () => {
	try {
		helper.loaderOn(twoFactorBlock.value);
		const response = await auth.enableTwoFactor();
		if(response.status === 200) {
			let qrResponse = await auth.twoFactorQrCode();
			if(qrResponse.response.status === 200) {
				twoFAQRCodes.value = qrResponse.data;
				twoFactorSetupSvg.value = qrResponse.svg;
				twoFactorSetupCode.value = qrResponse.code;
			}
		}
		helper.loaderOff(twoFactorBlock.value);
	} catch (error) {
		helper.loaderOff(twoFactorBlock.value);
	}
}

</script>

<style scoped lang="scss">
.w-40 {
	width: 40%;
}
.h-full-page{
	height: calc(100vh - 5px);
}
</style>